import React, { useState, useEffect } from "react";
import "./Hero.css";
import plane from "../../../../assets/images/home/hero-plane.svg";
import { Container, Tabs, Tab, Row, Col } from "react-bootstrap";
import packages from "../../../../assets/images/home/package.svg";
import filght from "../../../../assets/images/home/flight.svg";
import hotel from "../../../../assets/images/home/hotels.svg";
import arrow from "../../../../assets/images/home/arrow.svg";
import calender from "../../../../assets/images/home/calender.svg";
import search from "../../../../assets/images/home/search.svg";
import { axiosGet } from "../../../../utils/apis/api";
import axios from "axios";

import down from "../../../../assets/images/home/bottom-hero.svg";
import { TextField, Autocomplete } from "@mui/material";
import Cookies from "js-cookie";
import { useTranslation } from "../../../../contexts/TranslationContext";
import { useNavigate, useLocation, Link } from "react-router-dom";

// Import the HotelSearchBar component
import { HotelSearchBar } from "../../../HotelList";

const Hero = ({ pageData, url }) => {
  const heroData = pageData?.templates?.find(
    (template) => template.section === "Hero"
  );

  const {
    hero_title,
    hero_subtitle,
    hero_background_video,
    hero_icon,
  } = heroData?.data || {};
  const Lang = Cookies.get("preferred_language") || "en";
  const hasCookies = Cookies.get("api_key") && Cookies.get("api_secret") ;

  const [locations, setLocations] = useState([]);
  const [hasMorelocations, setHasMorelocations] = useState(true);
  const PAGE_LIMIT = 50;
  const [categories, setCategories] = useState([]);
  const [hasMoreCategories, setHasMoreCategories] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [searchText, setSearchText] = useState("");
  const navigate = useNavigate();

  const CATEGORY_PAGE_LIMIT = 50;
  const [toDestination, setToDestination] = useState(null);
  const { t } = useTranslation();

  // State for hotel search
  const [hotelSearchState, setHotelSearchState] = useState({
    destinationId: "",
    destination: "",
    checkin: "",
    checkout: "",
    travelers: "2",
    rooms: "1",
    search_type: "city",
    search_query: ""
  });
  
  const [travelers, setTravelers] = useState([
    {
      Adults: 2,
      Children: 0,
      ChildrenAges: [],
    },
  ]);

  const fetchLocations = async (
    newSearch = "",
    newStart = 0,
    append = false,
    only_used_location=true
  ) => {
    if (!hasMorelocations && append) return;
    try {
      const response = await axiosGet(
        `${url}/api/method/alltimes.www.api.locations`,
        {
          search: newSearch,
          start: newStart,
          limit: PAGE_LIMIT,
          only_used_location
        }
      );

      const newItems = Array.isArray(response.result?.locations)
        ? response.result?.locations
        : [];
      setLocations((prevItems) =>
        append ? [...prevItems, ...newItems] : newItems
      );
      setHasMorelocations(newItems.length === PAGE_LIMIT);
    } catch (error) {
      console.error("Error fetching items:", error);
      setLocations([]);
    } finally {
    }
  };
  
  useEffect(() => {
    fetchCategories("", 0, false);
  }, []);

  const fetchCategories = async (
    newSearch = "",
    newStart = 0,
    append = false
  ) => {
    if (!hasMoreCategories && append) return;
    try {
      const response = await axiosGet(
        `https://crm.alltimestravels.com/api/method/alltimes.www.api.package_categories`,
        {
          is_group: 0,
          search: newSearch,
          start: newStart,
          limit: CATEGORY_PAGE_LIMIT,
        }
      );

      const newItems = response?.result?.categories || [];

      setCategories((prevItems) =>
        append ? [...prevItems, ...newItems] : newItems
      );
      setHasMoreCategories(newItems.length === CATEGORY_PAGE_LIMIT);
    } catch (error) {
      console.error("Error fetching categories:", error);
      setCategories([]);
    }
  };

  useEffect(() => {
    fetchLocations("", 0, false);
  }, []);

  const handleDiscoverClick = () => {
    const search = searchText || "";
    const destinations = toDestination ? toDestination.name : "";
    const category = selectedCategory ? selectedCategory.name : "";

    const params = new URLSearchParams({
      search,
      destinations,
      category
    });

    navigate(`/packages?${params.toString()}`);
  };

  // Handler for hotel search
  const handleHotelDiscover = () => {
    const params = new URLSearchParams({
      destination: hotelSearchState.destination || "Dubai, United Arab Emirates",
      destinationId: hotelSearchState.destinationId || "",
      checkin: hotelSearchState.checkin || "",
      checkout: hotelSearchState.checkout || "",
      travelers: JSON.stringify(travelers), 
      rooms: travelers.length.toString(),
      search_type: hotelSearchState.search_type,
      search_query: hotelSearchState.search_query,
      q: String(Date.now()) // Add a timestamp to trigger a new search
    });

    navigate(`/hotels?${params.toString()}`);
  };


  return (
    <div className="hero">
      <img
        src={
          hero_background_video
            ? url + hero_background_video
            : require("../../../../assets/images/home/hero.png")
        }
        alt=""
        className="hero-background"
      />
      <Container>
        <div className="hero-content">
          <div className="hero-desc">{hero_subtitle}</div>
          <div className="hero-title">{hero_title}</div>
          <img
            className="hero-plane"
            data-aos="fade-down"
            data-aos-duration="1200"
            src={hero_icon ? url + hero_icon : plane}
            alt=""
          />
          <div
            className="hero-form"
            data-aos="fade"
            data-aos-duration="1200"
            data-aos-delay="900"
          >
            <Link to={`/${hasCookies ? "mypackages" : "login"}`} className="create-package-btn">
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 28 28" fill="none">
                <path d="M14 3.5C11.375 3.5 9.91668 4.2 9.91668 4.2V7L7.8581 9.05858C7.51218 9.4045 7.72043 9.98492 8.2081 10.0199C9.38468 10.1033 11.3779 10.2083 14 10.2083C15.2868 10.2083 16.422 10.1833 17.3833 10.1477H17.3734C17.5169 10.6673 17.5385 11.2131 17.4363 11.7425C17.3342 12.2718 17.1111 12.7704 16.7846 13.1994C16.458 13.6284 16.0368 13.9761 15.5537 14.2155C15.0707 14.4548 14.5388 14.5794 13.9997 14.5794C13.4606 14.5794 12.9288 14.4548 12.4457 14.2155C11.9626 13.9761 11.5414 13.6284 11.2149 13.1994C10.8883 12.7704 10.6652 12.2718 10.5631 11.7425C10.461 11.2131 10.4825 10.6673 10.626 10.1477C10.194 10.1317 9.79807 10.1142 9.43835 10.0952C9.29145 10.7759 9.29877 11.4809 9.45977 12.1584C9.62077 12.836 9.93137 13.4689 10.3688 14.0107C10.8062 14.5526 11.3594 14.9897 11.9877 15.29C12.616 15.5903 13.3036 15.7462 14 15.7462C14.6964 15.7462 15.384 15.5903 16.0123 15.29C16.6407 14.9897 17.1938 14.5526 17.6312 14.0107C18.0687 13.4689 18.3793 12.836 18.5403 12.1584C18.7013 11.4809 18.7086 10.7759 18.5617 10.0952C18.972 10.0737 19.3821 10.0484 19.7919 10.0193C20.2796 9.98433 20.4878 9.4045 20.1419 9.05858L18.0828 7V4.2C18.0828 4.2 16.625 3.5 14 3.5Z" fill="white"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.168 16.3578L17.9842 17.4936L21.255 15.2676C21.3427 15.2078 21.445 15.1731 21.5509 15.1672C21.6569 15.1613 21.7624 15.1844 21.8562 15.234C21.95 15.2837 22.0285 15.3579 22.0832 15.4488C22.1379 15.5398 22.1668 15.6439 22.1667 15.75V18.6666H21V16.8525L18.6667 18.4403V23.3333C18.6667 23.7813 18.8353 24.1908 19.1124 24.5H8.88771C9.16479 24.1908 9.33337 23.7813 9.33337 23.3333V18.3954L7.00004 16.8402V18.6666H5.83337V15.75C5.83336 15.6444 5.86201 15.5407 5.91628 15.4501C5.97055 15.3595 6.04839 15.2854 6.14151 15.2355C6.23463 15.1857 6.33952 15.1621 6.44501 15.1672C6.55049 15.1724 6.65261 15.206 6.74046 15.2646L10.0631 17.4796L13.8315 16.3578C13.8862 16.3414 13.943 16.3332 14 16.3333C14.0487 16.3333 14.0967 16.3393 14.1441 16.3514L14.1488 16.3526L14.168 16.3578ZM14.5834 17.6989L17.5 18.5669V23.3333H14.5834V17.6989ZM10.5 18.5669L13.4167 17.6989V23.3333H10.5V18.5669Z" fill="white"/>
                <path d="M21.5833 19.8333C21.1192 19.8333 20.6741 20.0177 20.3459 20.3459C20.0177 20.6741 19.8333 21.1192 19.8333 21.5833V22.75C19.8333 23.2141 20.0177 23.6592 20.3459 23.9874C20.6741 24.3156 21.1192 24.5 21.5833 24.5H24.5V21.5833C24.5 21.1192 24.3156 20.6741 23.9874 20.3459C23.6592 20.0177 23.2141 19.8333 22.75 19.8333H21.5833ZM5.25 19.8333C4.78587 19.8333 4.34075 20.0177 4.01256 20.3459C3.68437 20.6741 3.5 21.1192 3.5 21.5833V24.5H6.41667C6.8808 24.5 7.32591 24.3156 7.6541 23.9874C7.98229 23.6592 8.16667 23.2141 8.16667 22.75V21.5833C8.16667 21.1192 7.98229 20.6741 7.6541 20.3459C7.32591 20.0177 6.8808 19.8333 6.41667 19.8333H5.25Z" fill="white"/>
              </svg>
              <div className="create-package-btn-title">{t("CreateyourCustomPackage")} </div>
            </Link>
            <div className="hero-form-container">
              <Tabs defaultActiveKey="packages" id="hero-tabs" className="mb-3">
                <Tab
                  eventKey="packages"
                  title={
                    <span className="tab-title">
                      <img src={packages} alt="Flight" className="tab-icon" />
                      <div>{t("Package")}</div>
                    </span>
                  }
                >
                  <div className="filght-checkboxes">
                    <div className="hotel-form-input-container">
                      <label className="hotel-form-input-label">
                        {t("Destination")}
                      </label>
                      <Autocomplete
                        dir={Lang === "ar" ? "rtl" : "ltr"}
                        style={{ width: "100%" }}
                        options={locations}
                        value={toDestination}
                        onChange={(_, value) => setToDestination(value)}
                        onInputChange={(_, value) => {
                          fetchLocations(value);
                        }}
                        getOptionLabel={(option) => option?.location_name || ""}
                        sx={{
                          ".MuiAutocomplete-inputRoot": {
                            fontSize: "12px",
                            flexDirection:
                              Lang === "ar" ? "row-reverse" : "row",
                          },
                          ".MuiAutocomplete-endAdornment": {
                            left:
                              Lang === "ar"
                                ? "9 !important"
                                : "unset !important",
                            right:
                              Lang === "ar"
                                ? "unset !important"
                                : "9 !important",
                          },
                          ".MuiInputBase-input": {
                            textAlign: Lang === "ar" ? "right" : "left",
                          },
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            size="small"
                            placeholder={t("DestinationCity")}
                            InputProps={{
                              ...params.InputProps,
                              style: {
                                direction: Lang === "ar" ? "rtl" : "ltr",
                              },
                              sx: {
                                backgroundColor: "#FFF",
                                borderRadius: "6px",
                                padding: "9px 15px !important",
                                fontFamily: '"Dmsans400"',
                                fontSize: "14px !important",
                                fontWeight: 400,
                                letterSpacing: "0.25px",
                              },
                            }}
                          />
                        )}
                        renderOption={(props, option) => (
                          <li {...props} key={option.name}>
                            {option.location_name}
                          </li>
                        )}
                      />
                    </div>
                    <div className="hotel-form-input-container">
                      <label className="hotel-form-input-label">
                        {t("Category")}
                      </label>
                      <Autocomplete
                        dir={Lang === "ar" ? "rtl" : "ltr"}
                        style={{ width: "100%" }}
                        options={categories}
                        value={selectedCategory}
                        onChange={(_, value) => setSelectedCategory(value)}
                        onInputChange={(_, value) => {
                          fetchCategories(value);
                        }}
                        getOptionLabel={(option) => option?.category_name || ""}
                        sx={{
                          ".MuiAutocomplete-inputRoot": {
                            fontSize: "12px",
                            flexDirection:
                              Lang === "ar" ? "row-reverse" : "row",
                          },
                          ".MuiAutocomplete-endAdornment": {
                            left:
                              Lang === "ar"
                                ? "9 !important"
                                : "unset !important",
                            right:
                              Lang === "ar"
                                ? "unset !important"
                                : "9 !important",
                          },
                          ".MuiInputBase-input": {
                            textAlign: Lang === "ar" ? "right" : "left",
                          },
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            size="small"
                            placeholder={t("SelectCategory")}
                            InputProps={{
                              ...params.InputProps,
                              style: {
                                direction: Lang === "ar" ? "rtl" : "ltr",
                              },
                              sx: {
                                backgroundColor: "#FFF",
                                borderRadius: "6px",
                                padding: "9px 15px !important",
                                fontFamily: '"Dmsans400"',
                                fontSize: "14px !important",
                                fontWeight: 400,
                                letterSpacing: "0.25px",
                              },
                            }}
                          />
                        )}
                        renderOption={(props, option) => (
                          <li
                            {...props}
                            key={option.name}
                            style={{
                              fontFamily:
                                Lang === "ar" ? "Almarai300" : "Dmsans400",
                              direction: Lang === "ar" ? "rtl" : "ltr",
                              textAlign: Lang === "ar" ? "right" : "left",
                            }}
                          >
                            {option.category_name}
                          </li>
                        )}
                      />
                    </div>

                    <div className="hotel-form-input-container">
                      <label className="hotel-form-input-label">
                        {t("Search")}
                      </label>
                      <TextField
                        size="small"
                        placeholder={t("Search")}
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            fetchLocations(e.target.value, 0, false);
                            fetchCategories(e.target.value, 0, false);
                          }
                        }}
                        sx={{
                          mb: 2,
                          backgroundColor: "#FFF",
                          borderRadius: "6px",
                          fontFamily: '"Dmsans400"',
                          fontSize: "14px !important",
                          fontWeight: 400,
                          "& input::placeholder": {
                            fontFamily: '"Dmsans400"',
                            fontSize: "14px",
                          },
                        }}
                      />
                    </div>
                  </div>
                  <div className="flight-container">
                    <div className="flight-content">
                      <div>
                        <div className="flight-content-para">
                          {t("PackageText")}
                        </div>
                      </div>
                    </div>

                    <div className="discover-btn" onClick={handleDiscoverClick}>
                      <img src={search} alt="" />
                      <div>{t("Discover")}</div>
                    </div>
                  </div>
                </Tab>
                <Tab
                  eventKey="hotels"
                  title={
                    <span className="tab-title">
                      <img src={hotel} alt="Flight" className="tab-icon" />
                      <div>{t("Hotels")}</div>
                    </span>
                  }
                >
                  {/* Hotel Search Bar */}
                  <div className="hotel-search-container">
                    <HotelSearchBar 
                      value={hotelSearchState}
                      onChange={setHotelSearchState}
                      onDiscover={handleHotelDiscover}
                      travelers={travelers}
                      onTravelersChange={setTravelers}
                    />
                  </div>
                </Tab>
              </Tabs>
            </div>

          </div>
        </div>
      </Container>
      <img src={down} className="hero-down-image" />
    </div>
  );
};

export default Hero;